import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'estadonota'
})
export class EstadonotaPipe implements PipeTransform {

  transform(value: string): string {
    var result = '';
    switch (value) {
      case '1':
        result = 'Aceptado'
        break;
      case '2':
        result = 'Volver a Solicitar'
        break;
      case '3':
        result = 'En Espera'
        break;
      case '4':
        result = 'Rechazado'
        break;
      case '5':
        result = 'Adjuntado'
        break;
      case '6':
        result = 'No Adjuntado'
        break;
      default:
        result = 'No Adjuntado'
        break;
    }
    return result;
  }

}
